import React from 'react';
import { GenericPaginatedDocument } from '@/components/print/GenericPaginatedDocument';
import {
  buildCommercialA4PrintDocument,
  buildReportPrintDocument,
} from '@/print-engine/adapters/commercial-a4-adapter';
import type { PrintColumn, SimplePrintLine } from '@/print-engine';

type CommonProps = {
  title: string;
  documentNumber: string;
  partyName?: string;
  metaLines?: Array<{ label: string; value: string }>;
  introText?: string;
  columns: PrintColumn[];
  lines: SimplePrintLine[];
  finals?: Array<{ id: string; heightPx: number; keepTogetherWithNext?: boolean }>;
  finalBlocks?: Record<string, React.ReactNode>;
  onClose?: () => void;
  landscape?: boolean;
  docType?: string;
  /** Company letterhead header/footer (fills top band). */
  letterhead?: boolean;
};

/** A4 commercial document print via shared engine. */
export function EngineCommercialA4Print(props: CommonProps) {
  const model = buildCommercialA4PrintDocument({
    docType: props.docType || 'commercial',
    title: props.title,
    documentNumber: props.documentNumber,
    partyName: props.partyName || '',
    metaLines: props.metaLines,
    introText: props.introText,
    columns: props.columns,
    lines: props.lines,
    finals: props.finals,
    finalBlocks: props.finalBlocks,
    landscape: props.landscape,
    letterhead: props.letterhead,
  });
  return <GenericPaginatedDocument model={model} onClose={props.onClose} />;
}

/** Report-profile print (finance / ORC style). */
export function EngineReportPrint(props: {
  title: string;
  documentNumber: string;
  partyName?: string;
  metaLines?: Array<{ label: string; value: string }>;
  columns: PrintColumn[];
  lines: SimplePrintLine[];
  finalNote?: string;
  onClose?: () => void;
  docType?: string;
  /** A4 landscape report profile for wide registers. */
  landscape?: boolean;
}) {
  const model = buildReportPrintDocument({
    docType: props.docType || 'report',
    title: props.title,
    documentNumber: props.documentNumber,
    partyName: props.partyName,
    metaLines: props.metaLines,
    columns: props.columns,
    lines: props.lines,
    finalNote: props.finalNote,
    landscape: props.landscape,
  });
  return <GenericPaginatedDocument model={model} onClose={props.onClose} />;
}
